import React from 'react'
import { RSS } from 'thewest/routes/static/RSS/RSS'
import { createRegisterableComponent } from 'common/routing/page-definition'

export const RSSFeedsRegistration = createRegisterableComponent('rss-feeds', () => <RSS />)
